import React, {Fragment, useEffect, useState} from 'react';
import cn from 'classnames';
import { loadUpcomingBookings } from './api/BookingsApi';
import MonthSelect from "./MonthSelect";
import DesignerBooking from "./components/DesignerBooking";
import {differentDays} from "./Utils";

const DesignerBookings = ({ calendar }) => {
  const [currentDate, setCurrentDate] = useState(new Date());
  const [pageNumber, setPageNumber] = useState(0);
  const [bookings, setBookings] = useState([]);
  const [currentTime, setCurrentTime] = useState(new Date());
  const handleCalendarMonthChange = newDate => {
    setCurrentDate(newDate);
    console.log(newDate);
  };

  useEffect(() => {
      loadUpcomingBookings(
        calendar,
        null,
        currentDate,
        pageNumber,
        data => {
          setBookings(data.bookings);
        },
        error => {},
      );
    },
    [pageNumber, currentDate],
  );

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(() => new Date());
    }, 60000); // 1 minute
    return () => clearInterval(interval);
  }, []);

  let previousBooking;
  const setPreviousBooking = prevBooking => {
    const savedBooking = previousBooking;
    previousBooking = prevBooking;
    return savedBooking;
  };

  const pastBooking = booking => {
    const dateObj = new Date(booking.time_to);
    const londonDate = new Date(dateObj.toLocaleString("en-US", { timeZone: "Europe/London" }));
    const inPast = currentTime > londonDate;
    return inPast;
  };

  const upcomingBookings = bookings.filter(booking => !pastBooking(booking));
  const pastBookings = bookings.filter(pastBooking);
  return (
    <div className="designer-bookings">
      <div className='upcoming-bookings'>
        <div>
          <h2 className='title'>My Bookings</h2>
          <MonthSelect handleChange={handleCalendarMonthChange} />
        </div>
        <div>
          {upcomingBookings.map(booking => (
            <DesignerBooking upcoming={true} key={booking.id} booking={booking} previousBooking={setPreviousBooking(booking)} currentTime={currentTime} />
          ))}
          {pastBookings.map(booking => (
            <DesignerBooking upcoming={false} key={booking.id} booking={booking} previousBooking={setPreviousBooking(booking)} currentTime={currentTime} />
          ))}
          {bookings.length == 0 && (
            <div className='no-upcoming-bookings'>No bookings found</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default DesignerBookings;



// WEBPACK FOOTER //
// ./app/javascript/components/designer_calendars/DesignerBookings.js